<p class="paragraph-s">{{ 'GENERAL.DOWNLOADING' | translate }}</p>
<mat-progress-spinner color="primary" diameter="24" [mode]="(_mode | async) ?? 'indeterminate'" [value]="(_progress | async) ?? 0" />
<div class="ml-3" matSnackBarActions>
  <a matSnackBarAction acSecondaryLink (click)="dismiss()" (keydown.space)="dismiss()" (keydown.enter)="dismiss()">
    {{ 'GENERAL.CANCEL' | translate }}
  </a>
</div>
